var DealEventPipe, WishlistButton;

WishlistButton = window.WishlistButton != null ? window.WishlistButton : window.WishlistButton = {};

DealEventPipe = require('../../deal/frontend/event_pipe');

WishlistButton = function() {
  var $wishlistButton, $wishlistButtonTextAdd, $wishlistButtonTextRemove, addItemToWishlist, csrfToken, dealId, init, listenToOptionSelection, multiOptionBreakoutClicked, onAddItemSuccess, removeItemFromWishlist, selectedOptionUUID, toggleWishlistButtonStyle, updateRemoveItemUrl, updateWishlistedNotifier, wishlistButtonClicked, wishlistPayload;
  $wishlistButton = wishlistPayload = dealId = csrfToken = selectedOptionUUID = null;
  $wishlistButtonTextAdd = $wishlistButtonTextRemove = null;
  init = function(arg, done) {
    var $multiOptionBreakout, carousel, csrf, wishlist;
    carousel = arg.carousel, csrf = arg.csrf, wishlist = arg.wishlist;
    $wishlistButton = $(".add-to-wishlist-btn");
    $wishlistButtonTextAdd = $(".add-to-wishlist-btn-text-add");
    $wishlistButtonTextRemove = $(".add-to-wishlist-btn-text-remove");
    $multiOptionBreakout = $(".multi-option-breakout input");
    wishlistPayload = wishlist;
    dealId = carousel != null ? carousel.dealId : void 0;
    if (wishlistPayload.selectedOptionUUID) {
      selectedOptionUUID = wishlistPayload.selectedOptionUUID;
    }
    csrfToken = csrf;
    listenToOptionSelection();
    return $(function() {
      $wishlistButton.on("click", function(e) {
        return wishlistButtonClicked(e);
      });
      $multiOptionBreakout.on("click", multiOptionBreakoutClicked);
      return done();
    });
  };
  multiOptionBreakoutClicked = function(e) {
    var target;
    target = $(e.target);
    selectedOptionUUID = target.data("uuid");
    updateWishlistedNotifier(selectedOptionUUID);
    return updateRemoveItemUrl(selectedOptionUUID);
  };
  updateWishlistedNotifier = function(optionUUID) {
    var optionUUIDFilter;
    $wishlistButton.removeClass("wishlisted");
    $wishlistButtonTextAdd.removeClass("hidden");
    $wishlistButtonTextRemove.addClass("hidden");
    optionUUIDFilter = function(item) {
      return item.optionId === optionUUID;
    };
    if (optionUUID && _.filter(wishlistPayload.items, optionUUIDFilter).length > 0) {
      $wishlistButton.addClass("wishlisted");
      $wishlistButtonTextAdd.addClass("hidden");
      return $wishlistButtonTextRemove.removeClass("hidden");
    }
  };
  updateRemoveItemUrl = function(optionUUID) {
    var optionUUIDFilter, ref, ref1;
    optionUUIDFilter = function(item) {
      return item.optionId === optionUUID;
    };
    if (optionUUID) {
      return wishlistPayload.removeItemUrl = (ref = _.filter(wishlistPayload.items, optionUUIDFilter)) != null ? (ref1 = ref[0]) != null ? ref1.removeItemUrl : void 0 : void 0;
    }
  };
  listenToOptionSelection = function() {
    return DealEventPipe.on("priceUpdate", function(priceData) {
      var $tooltip;
      $tooltip = $('#select-option-tooltip');
      GIG.Tooltip.close($tooltip);
      selectedOptionUUID = priceData.variationsSelected && priceData.uuid;
      updateWishlistedNotifier(selectedOptionUUID);
      return updateRemoveItemUrl(selectedOptionUUID);
    });
  };
  toggleWishlistButtonStyle = function() {
    $wishlistButton.toggleClass("wishlisted");
    $wishlistButtonTextAdd.toggleClass("hidden");
    return $wishlistButtonTextRemove.toggleClass("hidden");
  };
  onAddItemSuccess = function(data) {
    var updateWishlistItems;
    updateWishlistItems = function(newItem) {
      var addedItem;
      addedItem = {
        dealId: dealId,
        itemId: newItem.itemId,
        listId: newItem.listId,
        removeItemUrl: "/deals/wishlists_proxy/remove/" + newItem.listId + "/" + newItem.itemId
      };
      if (selectedOptionUUID) {
        addedItem.optionId = selectedOptionUUID;
      }
      return wishlistPayload.items.push(addedItem);
    };
    wishlistPayload.removeItemUrl = "/deals/wishlists_proxy/remove/" + data.listId + "/" + data.itemId;
    toggleWishlistButtonStyle();
    return updateWishlistItems(data);
  };
  addItemToWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.addItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        dealId: dealId,
        optionId: selectedOptionUUID ? selectedOptionUUID : void 0,
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $(".wishlist-add-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, status, xhr) {
        return onAddItemSuccess(data);
      },
      complete: function() {
        return $wishlistButton.prop('disabled', false);
      }
    });
  };
  removeItemFromWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.removeItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $(".wishlist-remove-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, textStatus, error) {
        toggleWishlistButtonStyle();
        return wishlistPayload.items = _.filter(wishlistPayload.items, function(i) {
          return i.optionId !== selectedOptionUUID;
        });
      },
      complete: function() {
        return $wishlistButton.prop('disabled', false);
      }
    });
  };
  wishlistButtonClicked = function(e) {
    e.preventDefault();
    if ($wishlistButton.hasClass("wishlisted")) {
      return removeItemFromWishlist();
    } else {
      return addItemToWishlist();
    }
  };
  return {
    init: init,
    onAddItemSuccess: onAddItemSuccess
  };
};

window.WishlistButton = WishlistButton();

module.exports = WishlistButton;

//# sourceMappingURL=data:application/json;base64,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
